import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { FormularioDeLogin, useSesion } from '../sesion';

/** A dónde se vuelve tras entrar, si no había una ruta pedida. */
const DESTINO_POR_DEFECTO = '/';

/**
 * Pantalla de login.
 *
 * Vuelve a la ruta que la persona quiso abrir antes de que la mandaran acá
 * (`state.desde`, que pone `RutaProtegida`). Con el token en memoria esto pasa
 * seguido: recargar la página en cualquier pantalla termina en este login, y
 * sin esto siempre se caería en el inicio.
 */
export function Login() {
  const { sesion, cierre } = useSesion();
  const ubicacion = useLocation();
  const navegar = useNavigate();

  const estado = ubicacion.state as { desde?: string } | null;
  const destino = estado?.desde ?? DESTINO_POR_DEFECTO;

  // Ya hay sesión: no tiene sentido pedir la contraseña de nuevo.
  if (sesion) {
    return <Navigate to={destino} replace />;
  }

  return (
    <main>
      <h1>Facturador ARCA</h1>
      {cierre === 'salida' ? <p role="status">Cerraste la sesión.</p> : null}
      <FormularioDeLogin alEntrar={() => navegar(destino, { replace: true })} />
      <p className="nota">
        Esta pantalla es para personas. Los sistemas conectados se autentican con su API key y no
        pasan por acá.
      </p>
    </main>
  );
}
